import { Check } from 'lucide-react';

interface PricingProps {
  onNavigateToContact?: () => void;
}

const plans = [
  {
    name: 'Day Pass',
    price: '800',
    period: 'per day',
    description: 'Perfect for occasional visits',
    features: [
      'Access to hot desks',
      'High-speed WiFi',
      'Coffee & tea',
      'Printing credits',
      'Mail handling'
    ]
  },
  {
    name: 'Flexible',
    price: '6,000',
    period: 'per month',
    description: 'Ideal for freelancers and remote workers',
    features: [
      'Hot desk access',
      'All locations',
      '2 meeting room hours',
      'Unlimited printing',
      'Mail handling'
    ],
    popular: true
  },
  {
    name: 'Meeting Room',
    price: '1000',
    period: 'per hour',
    description: 'A modern and fully equipped meeting room',
    features: [
      '6-Seater Meeting Room',
      'Smart TV / Display Screen',
      'Video Conferencing Support',
      'Mail handling'
    ]
  }
];

export function Pricing({ onNavigateToContact }: PricingProps) {
  return (
    <section id="pricing" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl text-[#1F473E] mb-4">Simple Pricing</h2>
          <p className="text-xl text-[#49685E] max-w-2xl mx-auto">
            Choose the plan that fits your work style. All plans include access to our amenities.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className={`p-8 rounded-lg border-2 ${
                plan.popular 
                  ? 'border-[#49685E] bg-[#F1ECDC] shadow-xl shadow-[#1F473E]/20' 
                  : 'border-[#D8D7C8] bg-white hover:border-[#88998D] hover:shadow-lg'
              } transition-all`}
            >
              {plan.popular && (
                <div className="inline-block px-3 py-1 bg-[#1F473E] text-[#F1ECDC] rounded-full text-sm mb-4">
                  Most Popular
                </div>
              )}
              <h3 className="text-2xl text-[#1F473E] mb-2">{plan.name}</h3>
              <p className="text-[#49685E] mb-6">{plan.description}</p>
              <div className="mb-6">
                <span className="text-5xl text-[#1F473E]">₹{plan.price}</span>
                <span className="text-[#49685E] ml-2">{plan.period}</span>
              </div>
              <button 
                onClick={onNavigateToContact}
                className={`w-full px-8 py-3 rounded transition-all mb-6 shadow-lg shadow-[#1F473E]/20 ${
                plan.popular
                  ? 'bg-[#1F473E] text-[#F1ECDC] hover:bg-[#49685E]'
                  : 'border-2 border-[#1F473E] text-[#1F473E] hover:bg-[#1F473E] hover:text-[#F1ECDC]'
              }`}>
                Get Started
              </button>
              <ul className="space-y-3">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-[#49685E]">
                    <Check className="w-5 h-5 text-[#49685E] mr-2 flex-shrink-0 mt-0.5" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}